import React, { FC } from 'react';
import { Popconfirm } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';

interface IConfirmDelete {
  children: string | JSX.Element | JSX.Element[];
  handleDelete: (id?: number) => void;
  placement: TooltipPlacement;
  title?: string;
  description?: string;
}

const renderDescription = () => {
  return (
    <div style={{ width: 314 }}>
      Пользователь будет лишен доступа в систему и исчезнет из списка пользователей админ. панели.
    </div>
  );
};

export const ConfirmDelete: FC<IConfirmDelete> = ({
  children,
  handleDelete,
  placement,
  title,
  description,
}) => {
  return (
    <div className={'confirmDelete'}>
      <Popconfirm
        placement={placement}
        title={title || 'Вы действительно хотите удалить?'}
        description={description || renderDescription()}
        okText='Удалить'
        cancelText='Отмена'
        //eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        okButtonProps={{ onClick: handleDelete, danger: true }}
      >
        {children}
      </Popconfirm>
    </div>
  );
};
